var gearJS = {
  activeAjax           : {},
  confirmDialogAppended: false,
  allGears             : [],
  promptNeeded         : [],


  prepareConfirmText         : function($ele, text) {
    text = text.replace(/{if\(([^=<>()]*)([=<>]{1,3})([^=<>()]*)\)([^}]*)}/g, function(fullMatch, group1, group2, group3, group4) {
      switch (group2) {
        case "==":
        case "===":
        case "=":
        default:
          if ($ele.attr(group1) === group3) {
            return group4;
          }
          break;
        case "<":
          if (parseInt($ele.attr(group1)) < parseInt(group3)) {
            return group4;
          }
          break;

        case "<=":
          if (parseInt($ele.attr(group1)) <= parseInt(group3)) {
            return group4;
          }
          break;
        case ">":
          if (parseInt($ele.attr(group1)) > parseInt(group3)) {
            return group4;
          }
          break;
        case ">=":
          if (parseInt($ele.attr(group1)) >= parseInt(group3)) {
            return group4;
          }
          break;
      }

      return "";
    });

    if (typeof dataGridHelper === "undefined") {
      return text;
    }

    var $dataGridElement = gearJS.element($ele.gearJsAttr("data-gear-confirm-data-grid-count"), $ele);

    var thisDataGrid = $dataGridElement.dataGrid();

    if (thisDataGrid === false) {
      return text;
    }

    var numChecked = thisDataGrid.wrapper.find(".data-grid-checkbox-row:checked").length;
    var numAll     = thisDataGrid.wrapper.find(".data-grid-tbody").length;
    var numTotal   = parseInt(thisDataGrid.wrapper.attr("data-grid-total-records"));

    var replacePlural = "$1";

    if (numChecked === 1) {
      replacePlural = "";
    }
    var replaceSingle = "";

    if (numChecked === 1) {
      replaceSingle = "$1";
    }
    var replacePluralAll = "$1";

    if (numAll === 1) {
      replacePluralAll = "";
    }
    var replacePluralTotal = "$1";

    if (numTotal === 1) {
      replacePluralTotal = "";
    }

    var confirmSources = $ele.gearJsAttr("data-gear-confirm-sources");

    var customVars = gearJS.gatherDataInner($ele, confirmSources);

    for (var varName in customVars) {
      if (customVars.hasOwnProperty(varName)) {
        text = gearJS.handleCustomConfirmVariable(text, varName, customVars[varName]);
      }
    }
    return text.replace(/{#}/g, numChecked)
               .replace(/{pl=([^}]+)}/g, replacePlural)
               .replace(/{pl!=([^}]+)}/g, replaceSingle)
               .replace(/{#all}/g, numAll)
               .replace(/{pl:all=([^}]+)}/g, replacePluralAll)
               .replace(/{#total}/g, numTotal)
               .replace(/{pl:total=([^}]+)}/g, replacePluralTotal);
  },
  handleCustomConfirmVariable: function(text, customVarName, customVarValue) {
    if (typeof customVarValue === "object" && typeof customVarValue.value !== "undefined") {
      customVarValue = customVarValue.value;
    }
    var regex = new RegExp("{" + customVarName + "}", "g");
    return text.replace(regex, customVarValue);
  },
  confirm                    : function($ele, callback) {
    onConfirm({
      callback: callback,
      title   : gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-confirm-title")),
      body    : gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-confirm-body")),
      cancel  : gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-confirm-cancel")),
      yes     : gearJS.prepareConfirmText($ele, $ele.gearJsAttr("data-gear-confirm-yes")),
      yesType : $ele.gearJsAttr("data-gear-confirm-yes-class")
    });
  },
  auto                       : function($elem) {
    if (typeof $elem !== "undefined") {
      gearJS.init($elem.find("[data-gear-enabled='yes']"));
    }
    else {
      gearJS.init($("[data-gear-enabled='yes']"));
    }
  },
  hideErrors                 : function($ele) {
    var gearName = $ele.gearJsAttr("data-gear-name");
    $("[data-gear-error-name='" + gearName + "']").hide();
  },
  triggerFunction            : function($ele) {

    var debounceTime = $ele.gearJsAttr("data-gear-debounce-time");

    debounce(function() {
      gearJS.hideErrors($ele);
      var data = gearJS.gatherData($ele);
      if (gearJS.promptNeeded.length < 1) {
        gearJS.afterGatherData($ele, data);
      }
      else {
        var preparedPrompts = {};
        var options         = {};
        gearJS.promptNeeded.forEach(function(thisPrompt) {
          preparedPrompts[thisPrompt.fieldName] =
            {
              label        : thisPrompt.promptLabel,
              inputType    : thisPrompt.promptDialog.inputType,
              attr         : thisPrompt.promptDialog.attr,
              class        : thisPrompt.promptDialog.class,
              selectOptions: thisPrompt.promptDialog.selectOptions
            };

          if (thisPrompt.promptDialog.title !== null ||
              thisPrompt.promptDialog.msg !== null ||
              thisPrompt.promptDialog.yes !== null ||
              thisPrompt.promptDialog.no !== null ||
              thisPrompt.promptDialog.labelWidth !== null) {
            for (var propName in thisPrompt.promptDialog) {
              if (thisPrompt.promptDialog.hasOwnProperty(propName)) {
                if (thisPrompt.promptDialog[propName] !== null && thisPrompt.promptDialog[propName] !== undefined) {
                  options[propName] = thisPrompt.promptDialog[propName];
                }
              }
            }
          }

        });
        options.callback = function(userInput) {
          for (var prop in userInput) {
            if (userInput.hasOwnProperty(prop)) {
              data[prop] = userInput[prop];
            }
          }
          gearJS.afterGatherData($ele, data);
        };
        promptInput(preparedPrompts, options);
      }

    }, debounceTime);
  },
  afterGatherData            : function($ele, data) {
    var loadingToastMessage = $ele.gearJsAttr("data-gear-loading-toast");
    var loadingToastIcon    = $ele.gearJsAttr("data-gear-loading-toast-icon");
    var gearName            = $ele.gearJsAttr("data-gear-name");
    var cancelDuplicate     = $ele.gearJsAttr("data-gear-cancel-duplicate") === "yes";
    var loadingToast        = null;
    if (typeof loadingToast !== "undefined" && loadingToastMessage.length > 0) {
      loadingToast = toast({"message": loadingToastMessage, "time": -1, "icon": loadingToastIcon})
    }

    gearJS.runActions($ele.gearJsAttr("data-gear-trigger-actions"), loadingToast, $ele);

    if ($ele.gearJsAttr("data-gear-ajax-enabled") === "no") {
      return true;
    }

    if (typeof gearJS.activeAjax[gearName] === "undefined") {
      gearJS.activeAjax[gearName] = [];
    }


    if (cancelDuplicate) {
      gearJS.activeAjax[gearName].forEach(function(ajaxRequest) {
        ajaxRequest.abort();
      });
    }

    gearJS.activeAjax[gearName] = [];

    data._gear_mode = $ele.gearJsAttr("mode");


    // noinspection JSUnusedGlobalSymbols
    var ajaxRequest = $.ajax({
      url     : $ele.gearJsAttr("data-gear-ajax-url"),
      type    : "POST",
      data    : data,
      dataType: "json",
      success : function(response) {
        var toastUpdated = gearJS.runActions(response, loadingToast, $ele);
        if (!toastUpdated) {
          gearJS.runActions($ele.gearJsAttr("data-gear-default-update-toast"), loadingToast, $ele);
        }
      }, error: function(response) {
        var errorHandled = false;
        if (response.statusText !== "abort") {
          var error        = JSON.parse(response.responseText);
          var toastUpdated = false;
          if (typeof error.actions !== "undefined") {
            toastUpdated = gearJS.runActions(error.actions, loadingToast, $ele);
            errorHandled = true;
          }

          var errorToastMessage = {};
          var errorToastIcon    = $ele.gearJsAttr("data-gear-error-toast-icon");
          var errorToastType    = $ele.gearJsAttr("data-gear-error-toast-type");
          var errorToastAlways  = $ele.gearJsAttr("data-gear-error-toast-always") === "yes";
          var time              = $ele.gearJsAttr("data-gear-error-toast-time");


          if (typeof error.error !== "undefined") {
            if (loadingToast !== null && !toastUpdated) {
              loadingToast.set({time: 0});
            }
            errorToastMessage = error.error;
            errorHandled      = true;
          }
          else {
            if (!toastUpdated) {
              var errorToastSettings = {message: $ele.gearJsAttr("data-gear-error-toast"), icon: errorToastIcon, time: time, type: errorToastType};
              if (loadingToast !== null) {
                loadingToast.set(errorToastSettings);
              }
              else {
                toast(errorToastSettings);
              }
            }
          }


          if (errorToastMessage.length < 1) {
            time = 0;
          }
          for (var fieldName in errorToastMessage) {
            if (errorToastMessage.hasOwnProperty(fieldName)) {
              if ($.isArray(errorToastMessage[fieldName])) {
                errorToastMessage[fieldName].forEach(function(errorSingleMessage) {
                  gearJS.errorDisp($ele, errorSingleMessage, fieldName, errorToastAlways, errorToastIcon, time, errorToastType);
                });
              }
              else {
                gearJS.errorDisp($ele, errorToastMessage[fieldName], fieldName, errorToastAlways, errorToastIcon, time, errorToastType);
              }
            }
          }

          gearJS.runActions($ele.gearJsAttr("data-gear-error-actions"), loadingToast, $ele);

          if (!errorHandled) {
            console.log("Ajax error, response:");
            console.log(response);
          }
        }
        else {
          var cancelToastMessage = $ele.gearJsAttr("data-gear-cancel-toast");
          var cancelToastIcon    = $ele.gearJsAttr("data-gear-cancel-toast-icon");
          if (typeof cancelToastMessage === "undefined" || cancelToastMessage.length < 1) {
            if (loadingToast !== null) {
              loadingToast.close();
            }
            return true;
          }
          var toastSettings = {time: 1000, message: cancelToastMessage, type: "warning", icon: cancelToastIcon};
          if (loadingToast !== null) {
            loadingToast.set(toastSettings);
          }
          else {
            toast(toastSettings);
          }
        }

      }
    });
    gearJS.activeAjax[gearName].push(ajaxRequest);
  },
  checkDisableEvents         : function($ele, events) {
    return gearJS.addEvent($ele, events, function() {
      gearJS.checkEnabledStatus($ele);
    });

  },
  hideErrorEvents            : function($ele, events) {
    return gearJS.addEvent($ele, events, function() {
      gearJS.hideErrors($ele);
    });
  },
  addEvent                   : function($ele, events, callback) {
    var hasAnEvent = false;
    if (typeof events === "string") {
      try {
        events = JSON.parse(events);
      }
      catch (e) {
        return false;
      }
    }
    if (typeof events === "undefined") {
      return false;
    }
    if (typeof events.event === "undefined") {
      events.forEach(function(event) {
        if (gearJS.addEvent($ele, event, callback)) {
          hasAnEvent = true;
        }
      });
      return hasAnEvent;
    }
    var thisDataGrid;
    if (typeof events.dataGrid !== "undefined" && typeof dataGridHelper !== "undefined") {
      thisDataGrid = gearJS.element(events.dataGrid, $ele).dataGrid();
    }
    switch (events.event) {
      case "_dataGridCheck":
        if (typeof dataGridHelper === "undefined") {
          break;
        }
        hasAnEvent = true;
        dataGridHelper.addAdditionalBinding(thisDataGrid, {
          element: ".data-grid-checkbox-row", trigger: "change", callback: function() {
            callback();
          }
        });
        break;
      case "_dataGridDraw":
        if (typeof dataGridHelper === "undefined") {
          break;
        }
        hasAnEvent = true;
        thisDataGrid.onDraw(function() {
          callback();
        });
        break;
      case "_dataGridOpen":
        if (typeof dataGridHelper === "undefined") {
          break;
        }
        if (!$ele.closest(".data-grid-open").length) {
          break;
        }
        hasAnEvent = true;
        thisDataGrid.onOpen(function() {
          callback();
        });
        break;
      default:
        hasAnEvent        = true;
        var $eventElement = gearJS.element(events.element, $ele);
        $eventElement.on(events.event, function() {
          callback();
        });
        break;
    }
    return hasAnEvent;

  },
  startConditions            : function($ele, skipActions) {
    skipActions         = skipActions || false;
    var startConditions = $ele.gearJsAttr("data-gear-start-conditions");
    if (typeof startConditions === "undefined") {
      return true;
    }
    if (typeof startConditions === "string") {
      try {
        startConditions = JSON.parse(startConditions);
      }
      catch (e) {
        return false;
      }
    }
    var actionOnFalse = true;
    if (skipActions) {
      actionOnFalse = "noAction";
    }

    return gearJS.checkConditions(startConditions, $ele, actionOnFalse);
  },
  saveGearAttributes         : function(ele) {
    var gearID = $(ele).data("gear-js-id");
    if (typeof gearID !== "undefined" && gearID > 0) {
      return true;
    }
    var exportedName = $(ele).attr("data-gear-exported-name");
    var attributes   = {};
    if (typeof exportedName !== "undefined" && exportedName.length > 1) {
      attributes = _gear_exported_vars[exportedName];
    }

    // even if we already had the attributes loaded, overload anything that appears directly as an attribute.
    $.each(ele.attributes, function() {
      if (this.specified && this.name.substring(0, 10) === "data-gear-") {
        attributes[this.name.substring(10)] = this.value;
      }
    });
    gearJS.allGears.push(attributes);
    $(ele).data("gear-js-id", gearJS.allGears.length);

    // remove the attributes, we don't need them anymore...
    if (attributes["remove-attr"] !== "no") {
      attributes["exported-name"] = exportedName;
      // no need to do this right away, it's not absolutely required anyway.... (just makes the HTML cleaner)
      setTimeout(function() {
        gearJS.removeGearAttributes($(ele), attributes);
      }, 1000);
    }
  },
  removeGearAttributes       : function($ele, attributesToRemove) {
    for (var attrName in attributesToRemove) {
      if (attributesToRemove.hasOwnProperty(attrName)) {
        $ele.removeAttr("data-gear-" + attrName);
      }
    }
  },
  init                       : function($ele) {
    $ele.each(function() {
      gearJS.saveGearAttributes(this);
      // check if the attributes have been saved to "allGears"
      // if not saved yet, save them
      // Remove the unneeded attributes (but not right away, give it some breathing time)
      // allow an option to skip removing attributes
      var $ele    = $(this);
      var trigger = $ele.gearJsAttr("data-gear-trigger");
      if (typeof trigger === "undefined" || trigger.length < 1) {
        trigger = "click";
      }
      if (gearJS.checkDisableEvents($ele, $ele.gearJsAttr("data-gear-check-disable-events"))) {
        gearJS.checkEnabledStatus($ele);
      }
      gearJS.hideErrorEvents($ele, $ele.gearJsAttr("data-gear-hide-error-events"));

      $ele.off(trigger);
      $ele.on(trigger, function(e) {
        if ($ele.hasClass("disabled")) {
          e.preventDefault();
          return true;
        }
        if (!gearJS.startConditions($ele)) {
          e.preventDefault();
          return;
        }

        if ($ele.gearJsAttr("data-gear-confirm") === "yes") {
          gearJS.confirm($ele, function() {
            gearJS.triggerFunction($ele);
          });
        }
        else {
          gearJS.triggerFunction($ele);
        }


        e.preventDefault();
      });
      if (trigger === "gearJS_immediate") {
        $ele.trigger(trigger);
      }
    });

  },
  errorDisp                  : function($ele, message, fieldName, errorToastAlways, icon, time, type) {
    var identifier       = $ele.gearJsAttr("data-gear-identifier");
    var identifierClause = "";
    if (identifier.length > 1) {
      identifierClause = "[data-gear-identifier='" + identifier + "']";
    }
    var $errorWrapper = $("[data-gear-error='" + fieldName + "']" + identifierClause);
    if ($errorWrapper.length) {
      $errorWrapper.html(message);
      $errorWrapper.show();
      if (!errorToastAlways) {
        return true;
      }
    }
    toast({message: message, type: type, icon: icon, time: time});
  },
  runActions                 : function(response, loadingToast, $triggerElement) {
    if (typeof response === "undefined" || response === null) {
      return false;
    }
    if (typeof response === "string") {
      try {
        response = JSON.parse(response);
      }
      catch (e) {
        return false;
      }
    }
    var toastUpdated = false;
    if (typeof response._notact !== "undefined" && response._notact === true) {
      gearJS.checkConditions(response, $triggerElement);
      return true;
    }
    if (typeof response.action === "undefined" || response.action.length < 1) {
      response.forEach(function(singleResponse) {
        if (typeof singleResponse._notact !== "undefined" && singleResponse._notact === true) {
          gearJS.checkConditions(singleResponse, $triggerElement);
          return true;
        }
        var result;
        if (typeof singleResponse.action === "undefined" || singleResponse.action.length < 1) {
          result = gearJS.runActions(singleResponse, loadingToast, $triggerElement);
        }
        else {
          result = gearJS.runSingleAction(singleResponse, loadingToast, $triggerElement);
        }

        if (result === true) {
          toastUpdated = true;
        }
        if (result !== true && result !== false) {
          $triggerElement = result;
        }
      });
      return toastUpdated;
    }
    return gearJS.runSingleAction(response, loadingToast, $triggerElement);
  },
  runSingleAction            : function(response, loadingToast, $triggerElement) {
    if (typeof response._notact !== "undefined" && response._notact === true) {
      gearJS.checkConditions(response, $triggerElement);
      return true;
    }
    var action       = response.action;
    var toastUpdated = false;
    var $element;
    var $insertElement;
    var thisDataGrid = false;
    if (typeof response.dataGrid !== "undefined" && typeof dataGridHelper !== "undefined") {
      thisDataGrid = gearJS.element(response.dataGrid, $triggerElement).dataGrid();
    }
    delete response.action;
    switch (action) {
      case "update_toast":
        if (loadingToast !== null) {
          loadingToast.set(response);
        }
        toastUpdated = true;
        break;
      case "update_or_toast":
        if (loadingToast !== null) {
          loadingToast.set(response);
        }
        else {
          toast(response);
        }
        toastUpdated = true;
        break;
      case "toast":
        toast(response);
        break;
      case "console":
        console.log(response.content);
        break;
      case "data_grid_row":
        var gearName = $triggerElement.gearJsAttr("data-gear-name");
        var $newRow  = thisDataGrid.replaceRow(response.rowID, response.content);
        if ($newRow !== false) {
          if (typeof gearName === "string" && gearName.length > 0) {
            var $findGear = $newRow.find("[data-gear-name='" + gearName + "']");
            if ($findGear.length === 1) {
              return $findGear;
            }
          }
          return $newRow;
        }

        break;
      case "data_grid_detail":
        if (response.rowID === "_trigger") {
          response.rowID = $triggerElement.closest(".data-grid-tbody").attr("data-row-id");
        }

        thisDataGrid.addRowDetail(response.rowID, response.detail, response.rowClass, response.removePreviousDetail);
        break;
      case "data_grid_reload":
        thisDataGrid.search();
        break;
      case "data_grid_close_row":
        thisDataGrid.closeRow();
        break;
      case "data_grid_open_row":
        if (response.rowID === "_trigger") {
          response.rowID = $triggerElement.closest(".data-grid-tbody").attr("data-row-id");
        }
        var $rowToOpen = thisDataGrid.wrapper.find("tr[data-row-id='" + response.rowID + "']");
        if ($rowToOpen.length) {
          thisDataGrid.openRow($rowToOpen);
        }
        break;
      case "dropdown_init":
        $element = gearJS.element(response.element, $triggerElement);
        $element.dropdown("dispose");
        $element.dropdown();
        break;
      case "modal":
        $element = gearJS.element(response.element, $triggerElement);
        if (!$element.hasClass("modal")) {
          $element = $element.closest(".modal");
        }
        if (response.immediate === true) {
          $element.removeClass("fade");
        }
        $element.modal(response.function);
        if (response.immediate === true) {
          $element.addClass("fade");
        }
        break;
      case "hide":
        $element = gearJS.element(response.element, $triggerElement);
        $element.hide();
        break;
      case "show":
        $element = gearJS.element(response.element, $triggerElement);
        $element.show();
        break;
      case "toggle":
        $element = gearJS.element(response.element, $triggerElement);
        $element.toggle();
        break;
      case "setAttr":
        $element = gearJS.element(response.element, $triggerElement);
        $element.attr(response.attr, response.value);
        break;
      case "trigger":
        $element = gearJS.element(response.element, $triggerElement);
        $element.trigger(response.event);
        break;
      case "remove":
        $element = gearJS.element(response.element, $triggerElement);
        $element.remove();
        break;
      case "focus":
        $element = gearJS.element(response.element, $triggerElement);
        $element.focus();
        break;
      case "refresh":
        location.reload();
        break;
      case "redirect":
        location.replace(response.url);
        break;
      case "removeClass":
        $element = gearJS.element(response.element, $triggerElement);
        $element.removeClass(response.class);
        break;
      case "addClass":
        $element = gearJS.element(response.element, $triggerElement);
        $element.addClass(response.class);
        break;
      case "setValue":
        $element = gearJS.element(response.element, $triggerElement);
        $element.val(response.value);
        break;
      case "check":
        $element = gearJS.element(response.element, $triggerElement);
        $element.prop("checked", true);
        break;
      case "uncheck":
        $element = gearJS.element(response.element, $triggerElement);
        $element.prop("checked", false);
        break;
      case "javascript":
        eval(response.content);
        break;
      case "customFunction":
        window[response.function](gearJS.element(response.element, $triggerElement));
        break;
      case "insertBefore":
        $element = gearJS.element(response.element, $triggerElement);
        if (typeof response.insertElement !== "undefined" && response.insertElement !== null) {
          $insertElement = gearJS.element(response.insertElement, $triggerElement);
          $insertElement.insertBefore($element);
        }
        else {
          $insertElement = response.insertHtml;
          $element.before($insertElement);
        }
        gearJS.auto($element.parent());
        break;
      case "insertAfter":
        $element = gearJS.element(response.element, $triggerElement);
        if (typeof response.insertElement !== "undefined" && response.insertElement !== null) {
          $insertElement = gearJS.element(response.insertElement, $triggerElement);
          $insertElement.insertAfter($element);
        }
        else {
          $insertElement = response.insertHtml;
          $element.after($insertElement);
        }
        gearJS.auto($element.parent());
        break;
      case "html":
        $element = gearJS.element(response.element, $triggerElement);
        switch (response.mode) {
          case "append":
            $element.append(response.content);
            break;
          case "prepend":
            $element.prepend(response.content);
            break;
          case "replace":
          default:
            $element.html(response.content);
            break;
        }
        gearJS.auto($element);
        break;
      case "text":
        $element = gearJS.element(response.element, $triggerElement);
        switch (response.mode) {
          case "append":
            $element.append(response.content.replace(/&/g, "&amp;")
                                    .replace(/</g, "&lt;")
                                    .replace(/>/g, "&gt;")
                                    .replace(/"/g, "&quot;")
                                    .replace(/'/g, "&#039;"));
            break;
          case "prepend":
            $element.prepend(response.content.replace(/&/g, "&amp;")
                                     .replace(/</g, "&lt;")
                                     .replace(/>/g, "&gt;")
                                     .replace(/"/g, "&quot;")
                                     .replace(/'/g, "&#039;"));
            break;
          case "replace":
          default:
            $element.text(response.content);
            break;
        }
        break;
    }

    return toastUpdated;
  },
  gatherData                 : function($triggerElement) {
    gearJS.promptNeeded = [];
    var sources         = $triggerElement.gearJsAttr("data-gear-sources");
    return gearJS.gatherDataInner($triggerElement, sources);
  },
  gatherDataInner            : function($triggerElement, sources) {
    if (typeof sources === "undefined" || sources.length < 1) {
      return {};
    }
    if (typeof sources === "string") {
      try {
        sources = JSON.parse(sources);
      }
      catch (e) {
        console.log("Error, unable to parse sources");
        return {};
      }
    }
    var data = {};
    for (var i = 0; i < sources.length; i++) {
      var source = sources[i];
      gearJS.gatherSingleSource(data, source, $triggerElement);
      if (source.glue !== false && Array.isArray(data[source.fieldName])) {
        var result = "";
        var first  = true;
        data[source.fieldName].forEach(function(pieceOfResult) {
          if (!first) {
            result += source.glue;
          }
          if (typeof pieceOfResult === "object" && typeof pieceOfResult.value !== "undefined") {
            result += pieceOfResult.value;
          }
          else {
            result += pieceOfResult;
          }
          first = false;
        });
        data[source.fieldName] = result;
      }
    }

    return data;
  },
  gatherFromForm             : function(data, $element) {
    if ($element === false) {
      return true;
    }
    var additionalData = gearJS.serializedArrayToObject($element.serializeArray());
    for (var property in additionalData) {
      if (additionalData.hasOwnProperty(property)) {
        data[property] = additionalData[property];
      }
    }
  },
  gatherForDataGridQuery     : function(data, $element) {
    if ($element === false) {
      return true;
    }

    data["_dataGridGlobalInput"] = $element.dataGrid().gatherVars();
  },
  checkSingleCondition       : function(condition, $triggerElement, actionOnFalse) {
    var output            = true;
    var $ConditionElement = false;
    var thisDataGrid      = false;
    if (typeof condition.element !== "undefined") {
      $ConditionElement = gearJS.element(condition.element, $triggerElement);
    }
    if (typeof condition.dataGrid !== "undefined" && typeof dataGridHelper !== "undefined") {
      thisDataGrid = gearJS.element(condition.dataGrid, $triggerElement).dataGrid();
    }
    switch (condition.type) {
      case "exists":
        if ($ConditionElement === false || !$ConditionElement.length) {
          output = false;
        }
        break;
      case "checked":
        if ($ConditionElement === false || !$ConditionElement.length || !$ConditionElement.is(":checked")) {
          output = false;
        }
        break;
      case "unchecked":
        if ($ConditionElement === false || !$ConditionElement.length || $ConditionElement.is(":checked")) {
          output = false;
        }
        break;
      case "is":
        if ($ConditionElement === false || !$ConditionElement.is(condition.is)) {
          output = false;
        }
        break;
      case "dataGridOneChecked":
        if (thisDataGrid === false || thisDataGrid.checkedRows().length < 1) {
          output = false;
        }
        break;
      case "dataGrid":
        if (thisDataGrid === false) {
          output = false;
        }
        var $row;
        if (condition.rowID === "_trigger") {
          $row = dataGridHelper.getRowFromElement($triggerElement);
          if (!($row instanceof jQuery)) {
            break;
          }
        }
        else {
          $row = thisDataGrid.rowElem(condition.rowID);
        }


        var value = dataGridHelper.getRowDataValue($row, condition.columnName);
        if ($.isArray(condition.value)) {
          if ($.inArray(value, condition.value) === -1) {
            output = false;
          }
        }
        else {
          if (value !== condition.value) {
            output = false;
          }
        }

        break;
      case "dataGridOneCheckedValue":
        if (thisDataGrid === false || thisDataGrid.checkedRowsWithValue(condition.field, condition.value).length < 1) {
          output = false;
        }
        break;
      case "or":
        if (!gearJS.checkConditions(condition.conditions, $triggerElement, actionOnFalse, true)) {
          output = false;
        }
        break;
      case "dataGridNotOneChecked":
        if (thisDataGrid === false || thisDataGrid.checkedRows().length > 0) {
          output = false;
        }
        break;
      case "dataGridNotOneCheckedValue":
        if (thisDataGrid === false || thisDataGrid.checkedRowsWithValue(condition.field, condition.value).length > 0) {
          output = false;
        }
        break;
      case "attr":
        if ($.isArray(condition.value)) {
          if ($ConditionElement === false || $.inArray($ConditionElement.attr(condition.attr), condition.value) === -1) {
            output = false;
          }
        }
        else {
          if ($ConditionElement === false || $ConditionElement.attr(condition.attr) !== condition.value) {
            output = false;
          }
        }
        break;
      case "val":
        if ($.isArray(condition.value)) {
          if ($ConditionElement === false || $.inArray($ConditionElement.val(), condition.value) === -1) {
            output = false;
          }
        }
        else {
          if ($ConditionElement === false || $ConditionElement.val() !== condition.value) {
            output = false;
          }
        }

        break;
    }
    if (actionOnFalse !== "noAction") {
      if (((actionOnFalse && output === false) || (!actionOnFalse && output === true)) && typeof condition.action !== "undefined") {
        gearJS.runActions(condition.action, null, $triggerElement);
      }
    }
    return output;
  },
  checkConditions            : function(conditions, $triggerElement, actionOnFalse, orBinding) {
    actionOnFalse = actionOnFalse || false;
    orBinding     = orBinding || false;
    var thisActionOnFalse;
    var output    = true;
    if (orBinding) {
      output = false;
    }
    if (typeof conditions.type !== "undefined" && conditions.type.length > 0) {
      conditions = [conditions];
    }
    for (var j = 0; j < conditions.length; j++) {
      var condition     = conditions[j];
      thisActionOnFalse = actionOnFalse;
      if (condition.actionOnFalse !== "default") {
        thisActionOnFalse = condition.actionOnFalse;
      }
      if (gearJS.checkSingleCondition(condition, $triggerElement, thisActionOnFalse)) {
        if (orBinding) {
          output = true;
        }
      }
      else {
        if (!orBinding) {
          output = false;
        }
      }
    }
    return output;
  },
  gatherSingleSource         : function(data, source, $triggerElement) {
    var eachElement = false;
    var $eachElement;
    if (source.prompt) {
      gearJS.promptNeeded.push(source);
      return true;
    }
    if (typeof source.eachElement !== "undefined" && source.eachElement !== null) {
      eachElement  = true;
      $eachElement = gearJS.element(source.eachElement, $triggerElement);
    }

    if (!gearJS.checkConditions(source.conditions, $triggerElement, true)) {
      return true;
    }
    if (eachElement) {
      if ($eachElement === false) {
        if (typeof source.fieldName === "undefined" || source.fieldName.length < 1) {
          return true;
        }
        var field = source.fieldName;
        gearJS.addToData(data, field, "", true);
        return true;
      }
      $eachElement.each(function() {
        gearJS.gatherAfterVerify(data, source, $triggerElement, $(this));
      });
    }
    else {
      gearJS.gatherAfterVerify(data, source, $triggerElement);
    }
  },

  gatherAfterVerify: function(data, source, $triggerElement, $eachElement) {
    var $element;
    if (typeof source.element === "undefined" || source.element === null) {
      $element = $triggerElement;
    }
    else {
      $element = gearJS.element(source.element, $triggerElement, $eachElement);
    }
    var returnArray = source.array || false;
    for (var k = 0; k < source.eachConditions.length; k++) {
      var condition         = source.eachConditions[k];
      var $ConditionElement = gearJS.element(condition.element, $triggerElement, $eachElement);
      if ($ConditionElement === false || !$ConditionElement.is(condition.is)) {
        return true;
      }
    }

    if (typeof source.form !== "undefined" && source.form === true) {
      gearJS.gatherFromForm(data, $element);
      return true;
    }
    if (typeof source.fieldName === "undefined" || source.fieldName.length < 1) {
      return true;
    }
    var field = source.fieldName;

    if (typeof source.elementData !== "undefined" && source.elementData.length > 0) {
      var returnValue = $element.data(source.elementData);

      if (typeof source.elementDataSub !== "undefined" && source.elementDataSub.length > 0) {
        returnValue = returnValue[source.elementDataSub];
      }
      gearJS.addToData(data, field, returnValue, returnArray);
      return true;
    }

    if (typeof source.dataGridQuery !== "undefined" && source.dataGridQuery === true) {
      gearJS.gatherForDataGridQuery(data, $element);
      gearJS.addToData(data, field, "_dataGridQuery", returnArray);
      return true;
    }

    if (typeof source.value !== "undefined" && source.value !== null) {
      gearJS.addToData(data, field, source.value, returnArray);
      return true;
    }
    if (typeof source.fromDataGrid !== "undefined" && source.fromDataGrid === true) {

      gearJS.gatherFromDataGridColumn(data, source, field, $element, returnArray);
      return true;
    }

    if (typeof $element === "undefined" || $element === null || $element === false) {
      gearJS.addToData(data, field, "", returnArray);
      return true;
    }

    gearJS.gatherFromAttribute(data, source, field, $element, returnArray);
  },

  gatherFromDataGridColumn: function(data, source, field, $element, returnArray) {
    if (typeof dataGridHelper === "undefined") {
      gearJS.addToData(data, field, {rowID: 0, value: ""}, returnArray);
      return true;
    }

    if (typeof source.attribute === "undefined" || source.attribute.length < 1) {
      gearJS.addToData(data, field, {rowID: 0, value: ""}, returnArray);
      return true;
    }
    var $dataGridRow = dataGridHelper.getRowFromElement($element);
    var rowID        = $dataGridRow.attr("data-row-id");
    if (source.attribute === "row_id") {
      gearJS.addToData(data, field, rowID, returnArray);
      return true;
    }
    var value = dataGridHelper.getRowDataValue($dataGridRow, source.attribute);
    gearJS.addToData(data, field, {rowID: rowID, value: value}, returnArray);
    return true;
  },

  gatherFromAttribute: function(data, source, field, $element, returnArray) {
    var attribute;

    if (typeof source.attribute === "undefined" || source.attribute.length < 1) {
      attribute = "val";
    }
    else {
      attribute = source.attribute;
    }
    switch (attribute) {

      case "val":
        gearJS.addToData(data, field, $element.val(), returnArray);
        break;
      case "checked":
        gearJS.addToData(data, field, $element.is(":checked"), returnArray);
        break;
      case "unchecked":
        gearJS.addToData(data, field, !$element.is(":checked"), returnArray);
        break;
      default:
        gearJS.addToData(data, field, $element.attr(attribute), returnArray);
        break;

    }
    if (attribute === "val") {

    }
    else {

    }
  },

  addToData              : function(data, field, value, isArray) {
    if (isArray) {
      if (typeof data[field] === "undefined") {
        data[field] = [];
      }
      data[field].push(value);
    }
    else {
      data[field] = value;
    }
  },
  element                : function(elementObj, $triggerElement, $eachElement) {
    if (typeof elementObj === "string") {
      elementObj = JSON.parse(elementObj);
    }
    var $output  = null;
    var relative = "global";
    var selector;
    elementObj.trace.forEach(function(thisTrace) {
      selector = thisTrace[0];

      if (selector === "this") {
        selector = $eachElement;
      }
      if (selector === "trigger" || selector === "_trigger") {
        selector = $triggerElement;
      }
      if ($output === null) {
        if (selector instanceof jQuery) {
          $output = selector;
        }
        else {
          $output = $(selector);
        }

      }
      else {
        switch (relative) {
          case "find":
            $output = $output.find(selector);
            break;
          case "closest":
            $output = $output.closest(selector);
            break;
          default:
            $output = false;
            return false;
        }
      }
      relative = thisTrace[1];

    });
    if ($output !== null && ($output === false || !$output.length)) {
      return false;
    }


    selector = elementObj.selector;
    if (selector === "this") {
      selector = $eachElement;
    }
    if (selector === "trigger" || selector === "_trigger") {
      selector = $triggerElement;
    }
    if ($output === null) {
      relative = "no";
    }
    switch (relative) {
      case "find":
        if ($output !== null) {
          $output = $output.find(selector);
        }
        break;
      case "closest":
        if ($output !== null) {
          $output = $output.closest(selector);
        }
        break;
      default:
        $output = $(selector);
        break;

    }
    if ($output === false || !$output.length) {
      return false;
    }

    return $output;

  },
  serializedArrayToObject: function(array) {
    var output = {};
    array.forEach(function(element) {
      if (typeof output[element.name] === "undefined") {
        output[element.name] = element.value;
      }
      else {
        if (typeof output[element.name] === "object") {
          output[element.name].push(element.value);
        }
        else {
          output[element.name] = [output[element.name], element.value];
        }

      }

    });

    return output;
  },
  checkEnabledStatus     : function($ele) {

    var whenConditionsFail = $ele.attr("data-gear-when-conditions-fail");
    if (whenConditionsFail !== "hide") {
      whenConditionsFail = "disable";
    }

    var enabled = gearJS.startConditions($ele, true);
    if ($ele.is("form")) {
      $ele = $ele.find("[type=submit]");
    }

    if (enabled) {
      if (whenConditionsFail === "hide") {
        $ele.show();
      }
      else {
        $ele.removeClass("disabled");
      }
    }
    else {
      if (whenConditionsFail === "hide") {
        $ele.hide();
      }
      else {
        $ele.addClass("disabled");
      }
    }
  }
};

jQuery.fn.extend({
  gearJsAttr: function(attrName) {
    if (attrName.substring(0, 10) === "data-gear-") {
      attrName = attrName.substring(10);
    }
    var gearID = $(this).data("gear-js-id");
    if (typeof gearID === "undefined" || gearID < 1) {
      return $(this).attr("data-gear-" + attrName);
    }
    return gearJS.allGears[gearID - 1][attrName];

  }
});


gearJS.auto();

